<template>
  <div class="card-body">
    <h4 id="header-product-detail" class="card-title card-collapse">
      <span
        class="pointer"
        @click="
          detailComponentModel.collapseState = !detailComponentModel.collapseState
        "
        >Product Detail</span
      >
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="detailComponentModel.validateState == false"
          @click="
            detailComponentModel.collapseState = !detailComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            detailComponentModel.collapseState = !detailComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="detailComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-product-detail"
      v-model="detailComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <div class="pt-3">
          <div class="row">
            <div class="col-12">
              <div class="border-top pb-4"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-even">
              <!-- sku_mechanic_1 -->
              <div class="form-row">
                <!-- <label class="col-lg-3 col-xl-2 col-form-label">หน่วย</label> -->
                <div class="col-lg-3 col-xl-2">
                  <div class="row">
                    <div class="col-12 form-group">
                      <multiselect
                        v-model="detailComponentModel.model.sku_mechanics[0]"
                        :options="option_sku_mechanic_default_by_selected"
                        :custom-label="customlabel"
                        :show-labels="false"
                        :allowEmpty="false"
                        :disabled="true"
                        placeholder="เลือก Mechanic"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-light"
                        @click="onResetSku(0)"
                      >
                        <i class="bx bx-reset" />
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-9 col-xl-10">
                  <div class="row">
                    <div
                      class="col-3"
                      v-for="(data, index) in detailComponentModel.model
                        .sku_mechanics[0].values"
                      :key="index"
                    >
                      <div
                        class="form-group inline-icon"
                        v-if="
                          detailComponentModel.model.sku_mechanics[0] &&
                            option_sku_mechanic_values &&
                            option_sku_mechanic_values.length > 0
                        "
                      >
                        <validationProvider
                          v-slot="{ errors }"
                          :name="`sub_sku_mechanics_0_selector_${index}`"
                          :rules="{
                            validateDisplayNameObjectEng: true,
                          }"
                        >
                          <multiselect
                            v-model="
                              detailComponentModel.model.sku_mechanics[0]
                                .values[index]
                            "
                            :options="
                              option_sku_mechanic_values.some(
                                f =>
                                  f.collection ==
                                    detailComponentModel.model.sku_mechanics[0]
                                      .collection &&
                                  f.id ==
                                    detailComponentModel.model.sku_mechanics[0]
                                      .id
                              )
                                ? option_sku_mechanic_values.find(
                                    f =>
                                      f.collection ==
                                        detailComponentModel.model
                                          .sku_mechanics[0].collection &&
                                      f.id ==
                                        detailComponentModel.model
                                          .sku_mechanics[0].id
                                  ).option_values
                                : []
                            "
                            :custom-label="customlabel"
                            :show-labels="false"
                            :allowEmpty="false"
                            :class="{ 'is-invalid': errors && errors.length }"
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === false || isMechanicDisable
                            "
                          />
                          <i
                            v-if="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === true &&
                                isMechanicDisable === false
                            "
                            class="bx bx-trash icon-danger"
                            @click="onRemoveUnit(index, 0)"
                          ></i>
                          <div
                            v-if="errors && errors.length"
                            class="validate-invalid invaild-left-bottom"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="onAddSku(0)"
                      >
                        <i class="bx bx-plus" />
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- sku_mechanic_2 -->
              <div class="form-row">
                <div class="col-lg-3 col-xl-2">
                  <div class="row">
                    <div class="col-12 form-group">
                      <multiselect
                        v-model="detailComponentModel.model.sku_mechanics[1]"
                        :options="option_sku_mechanic_default_by_selected"
                        :custom-label="customlabel"
                        :show-labels="false"
                        :allowEmpty="false"
                        :disabled="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === false || isMechanicDisable
                        "
                        placeholder="เลือก Mechanic"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-light"
                        @click="onResetSku(1)"
                      >
                        <i class="bx bx-reset" />
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-9 col-xl-10"
                  v-if="
                    detailComponentModel.model.sku_mechanics[1] &&
                      detailComponentModel.model.sku_mechanics[1].display_name
                        .th &&
                      option_sku_mechanic_values &&
                      option_sku_mechanic_values.length > 0
                  "
                >
                  <div class="row">
                    <div
                      class="col-3"
                      v-for="(data, index) in detailComponentModel.model
                        .sku_mechanics[1].values"
                      :key="index"
                    >
                      <div
                        class="form-group inline-icon"
                        v-if="
                          detailComponentModel.model.sku_mechanics[1].type ==
                            'Database'
                        "
                      >
                        <validationProvider
                          v-slot="{ errors }"
                          :name="`sub_sku_mechanics_1_selector_${index}`"
                          :rules="{
                            validateDisplayNameObjectEng: true,
                          }"
                        >
                          <multiselect
                            v-model="
                              detailComponentModel.model.sku_mechanics[1]
                                .values[index]
                            "
                            :options="
                              option_sku_mechanic_values.some(
                                f =>
                                  f.collection ==
                                    detailComponentModel.model.sku_mechanics[1]
                                      .collection &&
                                  f.id ==
                                    detailComponentModel.model.sku_mechanics[1]
                                      .id
                              )
                                ? option_sku_mechanic_values.find(
                                    f =>
                                      f.collection ==
                                        detailComponentModel.model
                                          .sku_mechanics[1].collection &&
                                      f.id ==
                                        detailComponentModel.model
                                          .sku_mechanics[1].id
                                  ).option_values
                                : []
                            "
                            :custom-label="customlabel"
                            :show-labels="false"
                            :allowEmpty="false"
                            :class="{ 'is-invalid': errors && errors.length }"
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === false || isMechanicDisable
                            "
                          />
                          <i
                            v-if="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === true &&
                                isMechanicDisable === false
                            "
                            class="bx bx-trash icon-danger"
                            @click="onRemoveUnit(index, 1)"
                          ></i>
                          <div
                            v-if="errors && errors.length"
                            class="validate-invalid invaild-left-bottom"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                      <div class="form-group inline-icon" v-else>
                        <validationProvider
                          v-slot="{ errors }"
                          :name="`sub_sku_mechanics_1_input_${index}`"
                          :rules="{
                            dynamicRequired: ['กรุณาระบุข้อมูล'],
                          }"
                        >
                          <input
                            v-model="
                              detailComponentModel.model.sku_mechanics[1]
                                .values[index].display_name.th
                            "
                            type="text"
                            placeholder="กรุณาระบุข้อมูล"
                            class="form-control"
                            :class="{
                              'is-invalid': errors && errors.length,
                            }"
                            @input="
                              detailComponentModel.model.sku_mechanics[1].values[
                                index
                              ].display_name.en =
                                detailComponentModel.model.sku_mechanics[1].values[
                                  index
                                ].display_name.th
                            "
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === false || isMechanicDisable
                            "
                          />
                          <i
                            v-if="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === true &&
                                isMechanicDisable === false
                            "
                            class="bx bx-trash icon-danger"
                            @click="onRemoveUnit(index, 1)"
                          ></i>
                          <div
                            v-if="errors && errors.length"
                            class="validate-invalid invaild-left-bottom"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="onAddSku(1)"
                      >
                        <i class="bx bx-plus" />
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- sku_mechanic_3 -->
              <div class="form-row">
                <div class="col-lg-3 col-xl-2">
                  <div class="row">
                    <div class="col-12 form-group">
                      <multiselect
                        v-model="detailComponentModel.model.sku_mechanics[2]"
                        :options="option_sku_mechanic_default_by_selected"
                        :custom-label="customlabel"
                        :show-labels="false"
                        :allowEmpty="false"
                        :disabled="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === false || isMechanicDisable
                        "
                        placeholder="เลือก Mechanic"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-light"
                        @click="onResetSku(2)"
                      >
                        <i class="bx bx-reset" />
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-9 col-xl-10"
                  v-if="
                    detailComponentModel.model.sku_mechanics[2] &&
                      detailComponentModel.model.sku_mechanics[2].display_name
                        .th &&
                      option_sku_mechanic_values &&
                      option_sku_mechanic_values.length > 0
                  "
                >
                  <div class="row">
                    <div
                      class="col-3"
                      v-for="(data, index) in detailComponentModel.model
                        .sku_mechanics[2].values"
                      :key="index"
                    >
                      <div
                        class="form-group inline-icon"
                        v-if="
                          detailComponentModel.model.sku_mechanics[2].type ==
                            'Database'
                        "
                      >
                        <validationProvider
                          v-slot="{ errors }"
                          :name="`sub_sku_mechanics_2_selector_${index}`"
                          :rules="{
                            validateDisplayNameObjectEng: true,
                          }"
                        >
                          <multiselect
                            v-model="
                              detailComponentModel.model.sku_mechanics[2]
                                .values[index]
                            "
                            :options="
                              option_sku_mechanic_values.some(
                                f =>
                                  f.collection ==
                                    detailComponentModel.model.sku_mechanics[2]
                                      .collection &&
                                  f.id ==
                                    detailComponentModel.model.sku_mechanics[2]
                                      .id
                              )
                                ? option_sku_mechanic_values.find(
                                    f =>
                                      f.collection ==
                                        detailComponentModel.model
                                          .sku_mechanics[2].collection &&
                                      f.id ==
                                        detailComponentModel.model
                                          .sku_mechanics[2].id
                                  ).option_values
                                : []
                            "
                            :custom-label="customlabel"
                            :show-labels="false"
                            :allowEmpty="false"
                            :class="{ 'is-invalid': errors && errors.length }"
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === false || isMechanicDisable
                            "
                          />
                          <i
                            v-if="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === true &&
                                isMechanicDisable === false
                            "
                            class="bx bx-trash icon-danger"
                            @click="onRemoveUnit(index, 2)"
                          ></i>
                          <div
                            v-if="errors && errors.length"
                            class="validate-invalid invaild-left-bottom"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                      <div class="form-group inline-icon" v-else>
                        <validationProvider
                          v-slot="{ errors }"
                          :name="`sub_sku_mechanics_2_input_${index}`"
                          :rules="{
                            dynamicRequired: ['กรุณาระบุข้อมูล'],
                          }"
                        >
                          <input
                            v-model="
                              detailComponentModel.model.sku_mechanics[2]
                                .values[index].display_name.th
                            "
                            type="text"
                            placeholder="กรุณาระบุข้อมูล"
                            class="form-control"
                            :class="{ 'is-invalid': errors && errors.length }"
                            @input="
                              detailComponentModel.model.sku_mechanics[2].values[
                                index
                              ].display_name.en =
                                detailComponentModel.model.sku_mechanics[2].values[
                                  index
                                ].display_name.th
                            "
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === false || isMechanicDisable
                            "
                          />
                          <i
                            v-if="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === true &&
                                isMechanicDisable === false
                            "
                            class="bx bx-trash icon-danger"
                            @click="onRemoveUnit(index, 2)"
                          ></i>
                          <div
                            v-if="errors && errors.length"
                            class="validate-invalid invaild-left-bottom"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="onAddSku(2)"
                      >
                        <i class="bx bx-plus" />
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- sku_mechanic_4 -->
              <div class="form-row">
                <div class="col-lg-3 col-xl-2">
                  <div class="row">
                    <div class="col-12 form-group">
                      <multiselect
                        v-model="detailComponentModel.model.sku_mechanics[3]"
                        :options="option_sku_mechanic_default_by_selected"
                        :custom-label="customlabel"
                        :show-labels="false"
                        :allowEmpty="false"
                        :disabled="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === false || isMechanicDisable
                        "
                        placeholder="เลือก Mechanic"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-light"
                        @click="onResetSku(3)"
                      >
                        <i class="bx bx-reset" />
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-9 col-xl-10"
                  v-if="
                    detailComponentModel.model.sku_mechanics[3] &&
                      detailComponentModel.model.sku_mechanics[3].display_name
                        .th &&
                      option_sku_mechanic_values &&
                      option_sku_mechanic_values.length > 0
                  "
                >
                  <div class="row">
                    <div
                      class="col-3"
                      v-for="(data, index) in detailComponentModel.model
                        .sku_mechanics[3].values"
                      :key="index"
                    >
                      <div
                        class="form-group inline-icon"
                        v-if="
                          detailComponentModel.model.sku_mechanics[3].type ==
                            'Database'
                        "
                      >
                        <validationProvider
                          v-slot="{ errors }"
                          :name="`sub_sku_mechanics_3_selector_${index}`"
                          :rules="{
                            validateDisplayNameObjectEng: true,
                          }"
                        >
                          <multiselect
                            v-model="
                              detailComponentModel.model.sku_mechanics[3]
                                .values[index]
                            "
                            :options="
                              option_sku_mechanic_values.some(
                                f =>
                                  f.collection ==
                                    detailComponentModel.model.sku_mechanics[3]
                                      .collection &&
                                  f.id ==
                                    detailComponentModel.model.sku_mechanics[3]
                                      .id
                              )
                                ? option_sku_mechanic_values.find(
                                    f =>
                                      f.collection ==
                                        detailComponentModel.model
                                          .sku_mechanics[3].collection &&
                                      f.id ==
                                        detailComponentModel.model
                                          .sku_mechanics[3].id
                                  ).option_values
                                : []
                            "
                            :custom-label="customlabel"
                            :show-labels="false"
                            :allowEmpty="false"
                            :class="{ 'is-invalid': errors && errors.length }"
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === false || isMechanicDisable
                            "
                          />
                          <i
                            v-if="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === true &&
                                isMechanicDisable === false
                            "
                            class="bx bx-trash icon-danger"
                            @click="onRemoveUnit(index, 3)"
                          ></i>
                          <div
                            v-if="errors && errors.length"
                            class="validate-invalid invaild-left-bottom"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                      <div class="form-group inline-icon" v-else>
                        <validationProvider
                          v-slot="{ errors }"
                          :name="`sub_sku_mechanics_3_input_${index}`"
                          :rules="{
                            dynamicRequired: ['กรุณาระบุข้อมูล'],
                          }"
                        >
                          <input
                            v-model="
                              detailComponentModel.model.sku_mechanics[3]
                                .values[index].display_name.th
                            "
                            type="text"
                            placeholder="กรุณาระบุข้อมูล"
                            class="form-control"
                            :class="{ 'is-invalid': errors && errors.length }"
                            @input="
                              detailComponentModel.model.sku_mechanics[3].values[
                                index
                              ].display_name.en =
                                detailComponentModel.model.sku_mechanics[3].values[
                                  index
                                ].display_name.th
                            "
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === false || isMechanicDisable
                            "
                          />
                          <i
                            v-if="
                              dataPermissions.find(
                                f => f.name === 'sku_mechanics'
                              ).isEditable === true &&
                                isMechanicDisable === false
                            "
                            class="bx bx-trash icon-danger"
                            @click="onRemoveUnit(index, 3)"
                          ></i>
                          <div
                            v-if="errors && errors.length"
                            class="validate-invalid invaild-left-bottom"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 form-group">
                      <button
                        v-if="
                          dataPermissions.find(f => f.name === 'sku_mechanics')
                            .isEditable === true && isMechanicDisable === false
                        "
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="onAddSku(3)"
                      >
                        <i class="bx bx-plus" />
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2 text-left form-group">
              <button
                v-if="
                  dataPermissions.find(f => f.name === 'sku_mechanics')
                    .isEditable === true && isMechanicDisable
                "
                type="button"
                class="btn btn-warning"
                v-on:click="clearSKU('Edit Mechanic')"
              >
                <i class="bx bx-edit-alt" />Edit Mechanic
              </button>
            </div>
            <div
              class="col-10 text-right form-group"
              v-if="
                dataPermissions.find(f => f.name === 'sku_mechanics')
                  .isEditable === true
              "
            >
              <b-button
                type="button"
                class="btn btn-success"
                v-on:click="genSKU()"
              >
                <i v-if="genSkuTimerCount === 0" class="bx bx-loader" />
                <b-spinner v-else class="mr-1" small></b-spinner>
                Generate SKU
              </b-button>
              <button
                type="button"
                class="btn btn-light"
                v-on:click="clearSKU('Clear SKU')"
              >
                <i class="bx bx-reset" />
                Clear SKU
              </button>
            </div>
          </div>
          <TableProductDetail
            :generatesku="skuData"
            :basicModel="basicModel"
            ref="table_product_detail"
            :vendor_type="vendor_type"
            :discount_rate_1="discount_rate_1"
            :requestDocumentInformation="requestDocumentInformation"
            :is_free="is_free"
            :is_view="is_view"
            :vat_rate="vat_rate"
            :business_unit="business_unit"
            v-model="detailComponentModel.model.skus"
          />
        </div>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import TableProductDetail from '@/components/product-register/table-product-detail'
import Multiselect from 'vue-multiselect'
import { StatusEnum } from '@/enum/status.enum.js'
import attributeSkuMechanicService from '@/helpers/service/attribute-sku-mechanic-service'
import { eventBus } from '@/main.js'
import {
  navProductDetailComputed,
  navProductDetailMethods,
} from '@/state/helpers'
export default {
  name: 'ProductDetail',
  props: {
    value: {
      type: Object,
      default: () => {
        return this.detailComponentModel
      },
    },
    basicModel: {
      type: Object,
      default: () => {
        return {}
      },
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    discount_rate_1: {
      type: Number,
      default: () => {
        return 0.0
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    vat_rate: {
      type: Number,
      default: () => {
        return 0
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    business_unit : {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  components: {
    Multiselect,
    TableProductDetail,
  },
  data() {
    return {
      input: {},
      detailComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          sku_mechanics: [
            {
              id: '',
              display_name: { en: '', th: '' },
              type: '',
              collection: '',
              values: [
                {
                  id: '',
                  display_name: { en: '', th: '' },
                },
              ],
            },
            {
              id: '',
              display_name: { en: '', th: '' },
              type: '',
              collection: '',
              values: [
                {
                  id: '',
                  display_name: { en: '', th: '' },
                },
              ],
            },
            {
              id: '',
              display_name: { en: '', th: '' },
              type: '',
              collection: '',
              values: [
                {
                  id: '',
                  display_name: { en: '', th: '' },
                },
              ],
            },
            {
              id: '',
              display_name: { en: '', th: '' },
              type: '',
              collection: '',
              values: [
                {
                  id: '',
                  display_name: { en: '', th: '' },
                },
              ],
            },
          ],
          skus: [],
        },
      },
      genSkuTimerCount: 0,
      skuData: [],
      option_sku_mechanic_default: [],
      isFirstWatchValue: true,
      permissions: [
        {
          name: 'sku_mechanics',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      isSendEventProductLoaded: false,
    }
  },
  created() {
    this.onGetAttributeSkuMechanicSelector(false)
    eventBus.$on('collapse-product-detail', text => {
      this.detailComponentModel.collapseState = true

      // eventBus.$emit('collapse-table-product-detail', true)
      setTimeout(() => {
        this.onSubmit()
      }, 300)
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    option_sku_mechanic_values() {
      let sku_mechanic_1 = []
      if (
        this.detailComponentModel.model.sku_mechanics[0] &&
        this.detailComponentModel.model.sku_mechanics[0].type === 'Database' &&
        this.detailComponentModel.model.sku_mechanics[0].values &&
        this.detailComponentModel.model.sku_mechanics[0].values.length > 0 &&
        this.detailComponentModel.model.sku_mechanics[0].values.some(
          s => s.id !== ''
        )
      ) {
        sku_mechanic_1 = this.detailComponentModel.model.sku_mechanics[0].values.map(
          m => m.id
        )
      }
      let sku_mechanic_2 = []
      if (
        this.detailComponentModel.model.sku_mechanics[1] &&
        this.detailComponentModel.model.sku_mechanics[1].type === 'Database' &&
        this.detailComponentModel.model.sku_mechanics[1].values &&
        this.detailComponentModel.model.sku_mechanics[1].values.length > 0 &&
        this.detailComponentModel.model.sku_mechanics[1].values.some(
          s => s.id !== ''
        )
      ) {
        sku_mechanic_2 = this.detailComponentModel.model.sku_mechanics[1].values.map(
          m => m.id
        )
      }
      let sku_mechanic_3 = []
      if (
        this.detailComponentModel.model.sku_mechanics[2] &&
        this.detailComponentModel.model.sku_mechanics[2].type === 'Database' &&
        this.detailComponentModel.model.sku_mechanics[2].values &&
        this.detailComponentModel.model.sku_mechanics[2].values.length > 0 &&
        this.detailComponentModel.model.sku_mechanics[2].values.some(
          s => s.id !== ''
        )
      ) {
        sku_mechanic_3 = this.detailComponentModel.model.sku_mechanics[2].values.map(
          m => m.id
        )
      }

      let sku_mechanic_4 = []
      if (
        this.detailComponentModel.model.sku_mechanics[3] &&
        this.detailComponentModel.model.sku_mechanics[3].type === 'Database' &&
        this.detailComponentModel.model.sku_mechanics[3].values &&
        this.detailComponentModel.model.sku_mechanics[3].values.length > 0 &&
        this.detailComponentModel.model.sku_mechanics[3].values.some(
          s => s.id !== ''
        )
      ) {
        sku_mechanic_4 = this.detailComponentModel.model.sku_mechanics[3].values.map(
          m => m.id
        )
      }

      let options = this.option_sku_mechanic_default
      if (
        sku_mechanic_1.length > 0 ||
        sku_mechanic_2.length > 0 ||
        sku_mechanic_3.length > 0 ||
        sku_mechanic_4.length > 0
      ) {
        options.forEach(element => {
          element.option_values.forEach(value => {
            if (
              sku_mechanic_1.some(s => s === value.id) ||
              sku_mechanic_2.some(s => s === value.id) ||
              sku_mechanic_3.some(s => s === value.id) ||
              sku_mechanic_4.some(s => s === value.id)
            ) {
              value.$isDisabled = true
            } else {
              value.$isDisabled = false
            }
          })
        })
      }
      return options
    },
    option_sku_mechanic_default_by_selected() {
      if (
        this.option_sku_mechanic_default &&
        this.option_sku_mechanic_default.length > 0
      ) {
        let options = this.option_sku_mechanic_default

        if (this.detailComponentModel.model.sku_mechanics) {
          options.forEach(element => {
            element.$isDisabled = false
          })
          this.detailComponentModel.model.sku_mechanics.forEach(element => {
            if (element.id !== '') {
              options.find(f => f.id == element.id).$isDisabled = true
            }
          })
        }
        return options
      } else {
        return []
      }
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
    isMechanicDisable() {
      return (
        (this.skuData && this.skuData.length > 0) ||
        (this.detailComponentModel.model.skus &&
          this.detailComponentModel.model.skus.length > 0)
      )
    },
  },
  watch: {
    value: {
      handler(val) {
        if (this.isFirstWatchValue) {
          this.onGetAttributeSkuMechanicSelector(true)
        }
      },
      deep: true,
    },
    'detailComponentModel.model.skus': {
      handler(val) {
        this.onSubmit()
      },
      deep: true,
    },
    genSkuTimerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.genSkuTimerCount--
            // console.log(this.genSkuTimerCount)
          }, 1000)
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  methods: {
    ...navProductDetailMethods,
    modelChanged() {
      this.detailComponentModel.isPayloadChanged = true
      this.$emit('input', this.detailComponentModel)
    },
    onSubmit() {
      this.$refs.componentForm.validate().then(result => {
        //<SampleComponent :inputData.sync="parentData" />
        // this.$emit('update:isValidateSuccess', this.isValidateSuccess)
        let isSkuEditable =
          this.dataPermissions.find(f => f.name === 'sku_mechanics')
            .isEditable === true
        if (
          result &&
          this.detailComponentModel.model.skus &&
          !this.detailComponentModel.model.skus.some(
            s => s.validateState === false
          )
        ) {
          this.detailComponentModel.validateState = true
        } else if (isSkuEditable === false) {
          this.detailComponentModel.validateState = true
        } else {
          this.detailComponentModel.validateState = false
        }
        this.modelChanged()

        // if (this.isSendEventProductLoaded === false) {
        //   // console.log('send product-detail-loaded')
        //   // eventBus.$emit('product-detail-loaded')
        //   setTimeout(() => {
        //     this.$refs.table_product_detail.reCheckValidation() //recal product price cost
        //   }, 500)
        //   this.isSendEventProductLoaded = true
        // }
      })
    },
    onReset() {},
    onResetSku(index) {
      this.skuData = Object.assign([], this.skuData)
      if (index == 0) {
        this.onGetAttributeSkuMechanicSelector(false)
      } else {
        if (
          this.option_sku_mechanic_default_by_selected.find(
            f =>
              f.display_name.en ==
              this.detailComponentModel.model.sku_mechanics[index].display_name
                .en
          )
        ) {
          this.option_sku_mechanic_default_by_selected.find(
            f =>
              f.display_name.en ==
              this.detailComponentModel.model.sku_mechanics[index].display_name
                .en
          ).$isDisabled = false
        }
        this.detailComponentModel.model.sku_mechanics[index] = Object.assign(
          {},
          {
            id: '',
            display_name: { en: '', th: '' },
            type: '',
            collection: '',
            values: [{ id: '', display_name: { en: '', th: '' } }],
            isExist: false,
          }
        )
      }
    },
    onAddSku(order) {
      if (this.detailComponentModel.model.sku_mechanics[order].values) {
        this.detailComponentModel.model.sku_mechanics[order].values.push({
          id:
            this.detailComponentModel.model.sku_mechanics[order].type ===
            'FreeText'
              ? this.genHexString(24)
              : '',
          display_name: { en: '', th: '' },
        })
      }
    },
    async genSKU() {
      if (this.vendor_type == '') {
        document.getElementById('header-vendor').scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
        eventBus.$emit('collapse-vendor', true)
      } else {
        this.$refs.componentForm.validate().then(async result => {
          if (result) {
            await this.$utils
              .confirmAlertDisplay(`คุณต้องการ Generate SKU ใช่หรือไม่`, '')
              .then(result => {
                if (result) {
                  this.genSkuTimerCount = 2
                  this.skuData = []
                  this.detailComponentModel.model.sku_mechanics.forEach(
                    (element, index) => {
                      if (element.id !== '') {
                        this.skuData[index] = Object.assign(
                          {},
                          {
                            id: element.id,
                            display_name: {
                              en: element.display_name.en,
                              th: element.display_name.th,
                            },
                            type: element.type,
                            collection: element.collection,
                            values: element.values,
                          }
                        )
                      }
                    }
                  )
                  this.modelChanged()
                  this.$nextTick(() => {
                    this.SET_NAV_PRODUCT_DETAIL({
                      items: this.detailComponentModel.model.skus,
                      pageName: 'productRegister',
                    })
                  })
                }
              })
          }
        })
      }
    },
    async clearSKU(message) {
      await this.$utils
        .confirmAlertDisplay(
          `ข้อมูลในตาราง SKU ด้านล่างจะถูกล้างออก คุณต้องการ ${message} ใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.skuData = []
            this.detailComponentModel.model.skus = []
          }
        })
    },
    onRemoveUnit(index, order) {
      if (
        this.detailComponentModel.model.sku_mechanics[order].values &&
        this.detailComponentModel.model.sku_mechanics[order].values.length > 1
      )
        this.detailComponentModel.model.sku_mechanics[order].values.splice(
          index,
          1
        )
    },
    mappingData() {
      if (this.value) {
        this.detailComponentModel = this.value
        if (
          this.detailComponentModel.model.sku_mechanics &&
          this.detailComponentModel.model.sku_mechanics.length > 0
        ) {
          this.detailComponentModel.model.sku_mechanics.forEach(
            (element, index) => {
              if (element.id !== '') {
                this.skuData[index] = Object.assign(
                  {},
                  {
                    id: element.id,
                    display_name: {
                      en: element.display_name.en,
                      th: element.display_name.th,
                    },
                    type: element.type,
                    collection: element.display_name.collection,
                    values: element.values,
                    isExist: true,
                  }
                )
              }
            }
          )
        }
      }
    },
    async onGetAttributeSkuMechanicSelector(isWatch) {
      let params = new URLSearchParams()
      params.append('pageSize', 99999)
      params.append('sort', 'display_name.th display_name.en')
      params.append('status', StatusEnum.ACTIVE)
      params.append('isGetIncludeDatabaseValue', true)

      let result = await attributeSkuMechanicService.getAttributeSkuMechanicMasterListAsync(
        params
      )
      if (
        result.status === 200 &&
        result.data.items &&
        result.data.items.length > 0
      ) {
        let attributSkuMechanicItems = []
        result.data.items
          .sort((a, b) => (a.display_name.th > b.display_name.th ? 1 : -1))
          .forEach((element, index) => {
            attributSkuMechanicItems[index] = {
              id: element.id,
              display_name: {
                th: element.display_name ? element.display_name.th : '',
                en: element.display_name ? element.display_name.en : '',
              },
              type: element.type,
              collection: element.collection,
              values: [
                {
                  id: element.type === 'FreeText' ? this.genHexString(24) : '',
                  display_name: { en: '', th: '' },
                },
              ],
              option_values: element.values
                .sort((a, b) =>
                  a.display_name.th > b.display_name.th ? 1 : -1
                )
                .map(m => {
                  return { id: m._id, display_name: m.display_name }
                }),
              $isDisabled:
                (element.display_name ? element.display_name.en : '') == 'Unit'
                  ? true
                  : false,
            }
          })
        this.option_sku_mechanic_default = attributSkuMechanicItems
        if (isWatch) {
          this.isFirstWatchValue = false
          this.mappingData()
          this.onSubmit()
        } else if (
          this.detailComponentModel.model.sku_mechanics[0] &&
          this.detailComponentModel.model.sku_mechanics[0].id === ''
        ) {
          this.detailComponentModel.model.sku_mechanics[0] = this.option_sku_mechanic_default.some(
            f => f.display_name.th == 'หน่วย'
          )
            ? this.option_sku_mechanic_default.find(
                f => f.display_name.th == 'หน่วย'
              )
            : []
        }
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        }
      }
    },
    customlabel({ display_name }) {
      return display_name !== null && display_name !== undefined
        ? display_name.th !== '' && display_name.en !== ''
          ? `${display_name.th}  :  ${display_name.en}`
          : 'กรุณาเลือก'
        : ''
    },
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
    genHexString(len) {
      const hex = '0123456789abcdef'
      let output = ''
      for (let i = 0; i < len; ++i) {
        output += hex.charAt(Math.floor(Math.random() * hex.length))
      }
      return output
    },
  },
}
</script>
